import { KeyValue } from "@/main/models/common";

export const INITIAL_DATA_DOMAIN = {
	data: null as KeyValue[] | null,
	isLoading: false as boolean,
};

export type IInitialDataDomain = typeof INITIAL_DATA_DOMAIN;
